<mat-form-field appearance="outline" class="max-width no-hint">
  <mat-label>{{ 'general.api_cart_code_promo' | translate }}</mat-label>
  <input matInput type="text" name="promoCode" [(ngModel)]="promocode" (keyup)="utilService.isEnterKey($event) ? addPromoCode() : null"
         autocomplete="off" [matAutocomplete]="codesCacheAutocomplete">
  <a matSuffix class="link" (click)="$event.stopPropagation(); addPromoCode()">
    <span>{{ 'general.api_cart_code_promo_add' | translate }}</span>
  </a>
  <mat-autocomplete #codesCacheAutocomplete="matAutocomplete" (optionSelected)="codeSelectedFromCache($event)">
    <ng-container *ngIf="codesCache && !promocode">
      <mat-option *ngFor="let item of codesCache" [value]="item">
        {{item}}
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
<mat-chip-listbox *ngIf="hasLegacyPromocode">
  <mat-chip-option [matMenuTriggerFor]="promocodeInfo" [selectable]="false">
    {{service.cart.legacyPromocode.name}}
    <button matChipRemove (click)="removePromoCode()">
      <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
    </button>
  </mat-chip-option>
</mat-chip-listbox>
<mat-chip-listbox *ngIf="hasSelfServicePromocode">
  <mat-chip-option [selectable]="false">
    {{ selfServicePromocode }}
    <button matChipRemove (click)="removePromoCode()" [disabled]="service.isLoading">
      <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
    </button>
  </mat-chip-option>
</mat-chip-listbox>
<mat-menu #promocodeInfo="matMenu" class="limit-tooltip">
  <div class="corner"></div>
  <div class="info-message" *ngIf="!cartLimits.length">
    <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
    {{ 'general.api_cart_code_promo_no_limits' | translate }}
  </div>
  <table *ngIf="service.cart?.legacyPromocode && cartLimits.length">
    <ng-container *ngFor="let limit of cartLimits">
      <thead>
      <tr>
        <th colspan="3" class="align-left">{{ limit.name }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let detail of detailsAvailableLimits(limit.details); let i = index">
        <td *ngIf="detail.priceType && detailsPriceTypeFirstIndex(limit.details, detail.priceType) === i"
            [attr.rowspan]="detailsPriceTypeCount(limit.details, detail.priceType)">
          {{ detail.priceType | translate }}
        </td>
        <td [attr.colspan]="detail.priceType ? 1 : 2">
          {{ 'general.' + detail.name | translate }}
        </td>
        <td class="align-right">
          {{ (detail.max - detail.used) | quantityInPcs }}
        </td>
      </tr>
      </tbody>
    </ng-container>
  </table>
</mat-menu>
